import { type LearnMoreType } from 'src/context/store/app-provider';
import { type CountryName } from 'src/types/country-name';
import { type ExperimentResult } from 'src/types/experiment-result';
import { type ProductType } from 'src/types/product-type';
import { type getDeviceType } from 'src/utils/get-device-type';

export const SegmentEventType = {
  SNIPPET_CART_RENDERED: 'Snippet Cart Rendered',
  LEARN_MORE_CLICKED: 'Learn More Clicked',
  LEARN_MORE_POP_UP_OPENED: 'Learn More Pop Up Opened',
  LEARN_MORE_POP_UP_CLOSED: 'Learn More Pop Up Closed',
} as const;

export type SegmentEventType =
  (typeof SegmentEventType)[keyof typeof SegmentEventType];

export type TakeTypes<T, R extends T> = R;

export type SnippetType = 'fullInformation' | 'notFullInformation' | 'alshaya';

export type SourcePlugin =
  | 'woo'
  | 'shopify'
  | 'zid'
  | 'salla'
  | 'magento2'
  | 'opencart';

export interface GlobalAnalyticsProperties {
  merchantCode?: string;
  platformType: ReturnType<typeof getDeviceType>;
  productType?: TakeTypes<ProductType, 'installments'>;
  merchantId?: string;
  sourcePlugin?: SourcePlugin;
  ltfKsaSnippetExpValue?: ExperimentResult<'BNPL-11864-KSA-LTF-snippet'>;
}

export type SegmentEvent =
  | {
      event: typeof SegmentEventType.SNIPPET_CART_RENDERED;
      publicKey: 'yes' | 'no';
      planSelected?: number;
      snippetType: SnippetType;
      merchantCountry: CountryName;
      fingerprint?: string;
    }
  | {
      event: typeof SegmentEventType.LEARN_MORE_CLICKED;
      publicKey: 'yes' | 'no';
      merchantIntegrationType: 'popupOnly' | 'snippetAndPopup';
      planSelected?: number;
      snippetType: SnippetType;
      merchantCountry: CountryName;
      typeWidget:
        | LearnMoreType
        | 'card'
        | 'long-term'
        | 'alshaya-product'
        | 'non-standard';
    }
  | {
      event: typeof SegmentEventType.LEARN_MORE_POP_UP_OPENED;
      merchantIntegrationType: 'popupOnly' | 'snippetAndPopup';
      planSelected?: number;
      popupType:
        | 'standardWithInfo'
        | 'standardPickPayment'
        | 'standardWithoutInfo'
        | 'custom';
      merchantCountry: CountryName;
      publicKey: 'yes' | 'no';
      integrationType: 'native' | 'custom';
    }
  | {
      event: typeof SegmentEventType.LEARN_MORE_POP_UP_CLOSED;
      publicKey: 'yes' | 'no';
      merchantIntegrationType: 'popupOnly' | 'snippetAndPopup';
      planSelected?: number;
      popupType:
        | 'standardWithInfo'
        | 'standardPickPayment'
        | 'standardWithoutInfo'
        | 'custom';
      merchantCountry: CountryName;
      action: 'cross' | 'inactive zone' | 'continue';
    };
